import { Component } from '@angular/core';

import { ByocEpisodeService } from '../../service/episode.service';
import { Episode } from '@app/core/model/library.model';
import { Router } from '@angular/router';
import { UserService } from '@app/user';

@Component({
    selector: 'app-byoc-episode-step-recommend',
    templateUrl: './recommend.component.html',
    styleUrls: ['./recommend.component.scss'],
    standalone: false
})
export class ByocEpisodeStepRecommendComponent {
    constructor(
        private byocEpisodeService: ByocEpisodeService,
        private router: Router,
        private userService: UserService,
    ) {}

    /**
     * Get Episode
     */
    get episode(): Episode {
        return this.byocEpisodeService.episode;
    }

    /**
     * Get Affected Users Count
     */
    get affectedUsersCount(): number {
        return this.byocEpisodeService.affectedUsers;
    }

    get hasNoUsersAffected() {
        return this.affectedUsersCount === 0;
    }

    get hasAccessToAllContent() {
        return this.userService.user.options.special.explore.allContent;
    }

    /**
     * Cancel
     */
    closeClick(): void {
        this.byocEpisodeService.close('btn-close');
    }

    goToCourse() {
        const missionId = this.episode.course && this.episode.course.mission && this.episode.course.mission.id ? this.episode.course.mission.id : null;
        const courseId = this.episode.course && this.episode.course.id ? this.episode.course.id : null;
        const episodeId = this.episode.id;

        this.closeClick();

        if (courseId && missionId && episodeId) {
            this.router.navigate(['/episode', missionId, courseId, episodeId]);
            return;
        }
        if (courseId && episodeId) {
            this.router.navigate(['/episode', this.episode!.course!.id, this.episode.id]);
            return;
        }

        this.router.navigate(['/episode', this.episode.id]);
    }

    goToCustomContent() {
        this.closeClick();
        this.router.navigate(['/manager', 'settings', 'content', 'byoc', 'list']);
    }
}
